const CRUD = {
    CREATE: "Create",
    LIST: "List",
    UPDATE: "Update",
    DELETE: "Delete",
    VIEW: "View",
    DETAIL: "Detail",
    SAVE: "Save",
    APPROVE: "Approve",
    REFUND: "Refund",
};

export default Object.freeze({
    ...CRUD,
    USER: {
        ...CRUD,
        UNLOCK: "Unlock",
        APPROVE: "Approve",
        ENABLEDISABLE: "EnableDisable",
        UNBLOCK: "Unblock",
        BLOCK:'Block',
        RESETPASSSWORD: "ResetPassword",
        DEACTIVATE: "Deactivate",
    },
    ROLE: {
        ...CRUD,
        VIEW:'View'
    },
    SETUP: {
        ...CRUD,
    },
    DELETEEMPLOYEE: {
        RESTORE: "Restore",
        LIST: "LIST",
    },
    PENDINGROLE: {
        ...CRUD,
        APPROVE: "Approve",
        REJECT: "Reject",
    },
    TOPUP: {
        ...CRUD,
        APPROVE: "Approve",
        REJECT: "Reject",
        PREAPPROVE: "PreApprove",
    },
    NOTIFICATION: {
        ...CRUD,
        SEND: "Send",
    },
    RATE: {
        ...CRUD,
        LIST: "Create",
    },
});
